/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Bienvenido from "./Componentes/Home_Bienvenido";
import Home_Habitaciones from "./Componentes/Home_Habitaciones";
import Home_Servicio from "./Componentes/Home_Servicio";
import Home_Salon from "./Componentes/Home_Salon";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Home_Contactos from "./Componentes/Home_Contactos";
import Home_Frase from "./Componentes/Home_Frase";
import Home_Actividades from "./Componentes/Home_Actividades";
import Home_Nosotros from "./Componentes/Home_Nosotros";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {SECCIONES} from "../../Constantes";

const Seccion_Home = () => {
    const {sCell, masSM, sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', zIndex: 2, mt: sCell ? -38 : sTab ? -24 : -13}}>
                <Home_Bienvenido/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 28}}>
                <Home_Habitaciones/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 26}}>
                <Home_Servicio/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: !masSM ? 10 : 24}}>
                <Home_Salon/>
            </Grid>

            <Grid id={SECCIONES[2]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 20}}>
                <Home_Testimonios/>
            </Grid>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 18}}>
                <Home_Contactos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 18 : 24}}>
                <Home_Frase/>
            </Grid>

            <Grid id={SECCIONES[3]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 14 : 24}}>
                <Home_Actividades/>
            </Grid>

            <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 14}}>
                <Home_Nosotros/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Home